export const environment = {
  production: false,
  apiBaseUrl: 'https://api.uat.tasks.areeb.me/',
  useMockEncryption: false,
};

export const FILE_UPLOAD_URLs = {
  upload: environment.apiBaseUrl + '/api/v1/media',
  remove: environment.apiBaseUrl + '/api/v1/media',
};
